module.exports = __webpack_public_path__ + "static/media/6-elefant.8b3465fb.mp3";